import React, { ReactElement, Dispatch, SetStateAction, useEffect, RefObject } from 'react'
import { ICreatableSelectFieldOption } from '../../ICreatableSelectFieldOption'
import style from './List.module.css'

type ListProps<Option> = {
  selectItem: (value: Option) => void
  hoverItem: (value: number) => void
  renderItem(option: Option, inputValue: Option, isActive: boolean): ReactElement
  listItemHeightChange: Dispatch<SetStateAction<number>>
  listRef: RefObject<HTMLUListElement>
  listItemHeight: number
  countOfListItems: number
  activeItem: number
  value: Option
  options: ICreatableSelectFieldOption<Option>[]
}

export const List = <Option,>({
  renderItem,
  selectItem,
  hoverItem,
  listItemHeightChange,
  options,
  listRef,
  activeItem,
  value,
  countOfListItems,
  listItemHeight,
}: ListProps<Option>): ReactElement => {
  useEffect(() => {
    if (listRef.current) {
      const { height } = (listRef.current.firstChild as HTMLLIElement).getBoundingClientRect()

      listItemHeightChange(height)
    }
  }, [listItemHeightChange, listRef])

  return (
    <ul
      // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
      tabIndex={0}
      data-creatableselectfield
      ref={listRef}
      className={style.list}
      style={{
        height: listItemHeight * countOfListItems,
      }}
    >
      {options &&
        options.map(({ option, key }, index: number) => (
          <li key={key} onMouseDown={() => selectItem(option)} onMouseMove={() => hoverItem(index)}>
            {renderItem(option, value, index === activeItem)}
          </li>
        ))}
    </ul>
  )
}

List.displayName = 'List'
